import {
  NBS_API_GET_FORGOT_PASSWORD_REQUEST,
  NBS_API_GET_FORGOT_PASSWORD_SUCCESS,
  NBS_API_GET_FORGOT_PASSWORD_FAILURE
} from '../../constants/actions';
import nbsApi from '../../assets/helpers/nbsApi';
import strings from '../../assets/localization';

function nbsApiForgotPasswordRequest () {
  return { type: NBS_API_GET_FORGOT_PASSWORD_REQUEST };
}
function nbsApiForgotPasswordSuccess (response) {
  return {
    type: NBS_API_GET_FORGOT_PASSWORD_SUCCESS,
    response
  };
}
function nbsApiForgotPasswordFailure (error) {
  return {
    type: NBS_API_GET_FORGOT_PASSWORD_FAILURE,
    error: error.cause || error
  };
}
export function nbsApiForgotPassword (emailAddress) {
  const url = 'forgotPassword';
  return dispatch => {
    dispatch(nbsApiForgotPasswordRequest());
    return nbsApi(url, { email: emailAddress, language: strings.getLanguage() })
      .then(response => dispatch(nbsApiForgotPasswordSuccess(response)))
      .catch(error => dispatch(nbsApiForgotPasswordFailure(error)));
  };
}
